import { defineComponent as _defineComponent } from 'vue'
import { currentLocale as getCurrentLocale } from '@/utils/i18n';
import { localeService } from '@/library-services/locale.service';
import { getLocaleFullName } from '@/locale/dictLocale';
import { computed } from 'vue';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelectorModal',
  emits: ["select-language", "close"],
  setup(__props, { emit }: { emit: ({
  (e: 'select-language', locale: string): void;
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {



const { t } = useI18n();

async function setLocale(locale: string) {
  await localeService.setCurrentLocale(locale);
  emit('select-language', locale);
  emit('close');
}

const locales = computed(() => localeService.availableLocales);
const currentLocale = computed(() => getCurrentLocale());

return { __sfc: true,emit, t, setLocale, locales, currentLocale, getLocaleFullName }
}

})